export const BASE_URL = window.__RUNTIME_CONFIG__?._BASE_URL || process.env.REACT_APP_BASE_URL || '';
export const CLIENT_APP_URL = window.__RUNTIME_CONFIG__?._CLIENT_BASE_URL || process.env.REACT_APP_CLIENT_BASE_URL;
export const POOL_APP_URL = window.__RUNTIME_CONFIG__?._POOL_APP_URL || process.env.REACT_APP_POOL_URL;
export const CAPTCHA_TYPE = window.__RUNTIME_CONFIG__?._CAPTCHA_TYPE || process.env.REACT_APP_CAPTCHA_TYPE;
export const GOOGLE_CAPTCHA_KEY =
  window.__RUNTIME_CONFIG__?._GOOGLE_CAPTCHA_KEY || process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;
export const GOOGLE_CAPTCHA_KEY_2 =
  window.__RUNTIME_CONFIG__?._GOOGLE_CAPTCHA_KEY_2 || process.env.REACT_APP_GOOGLE_CAPTCHA_KEY_2;
export const YANDEX_CAPTCHA_KEY =
  window.__RUNTIME_CONFIG__?._YANDEX_CAPTCHA_KEY || process.env.REACT_APP_YANDEX_CAPTCHA_KEY;
